"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComfortStarsPerSolution = exports.getComfortDeltaBySolution = exports.maxPointsPerSolution = exports.getCurrentSolutionComfort = exports.getGlazingComfortScore = exports.getComfortClass = void 0;
const glass_1 = require("./glass");
const solution_1 = require("./solution");
/** Translate the comfortScore to a 1 to 5-star class based on Cauberg Huygen */
function getComfortClass(score) {
    if (score > 50)
        return 5;
    if (score > 40)
        return 4;
    if (score > 30)
        return 3;
    if (score > 20)
        return 2;
    return 1;
}
exports.getComfortClass = getComfortClass;
const getGlazingComfortScore = (u) => {
    const type = (0, glass_1.getGlazingType)(u);
    const mapping = {
        [glass_1.GlassType.Single]: 0,
        [glass_1.GlassType.Double]: 1,
        [glass_1.GlassType.HR]: 1,
        [glass_1.GlassType.HRp]: 1,
        [glass_1.GlassType.HRpp]: 2,
        [glass_1.GlassType.Triple]: 3,
        [glass_1.GlassType.Vacuum]: 3,
    };
    return mapping[type];
};
exports.getGlazingComfortScore = getGlazingComfortScore;
function getCurrentSolutionComfort(solution, comfortProps) {
    const { houseType, wallsRc, floorRc, roofRc, livingU, sleepingU, heatEmissionSystems } = comfortProps;
    const noFloor = [5, 7, 9, 11, 13, 15, 17, 19, 21].some(t => t === houseType);
    const noRoof = [5, 8, 9, 12, 13, 16, 17, 20, 21].some(t => t === houseType);
    /** The assumption is made that there is weatherStripping if both walls and roof are 'matig' insulated */
    switch (solution) {
        case solution_1.Solution.WallInsulation:
            return wallsRc > 1.92 ? 5 : 2;
        case solution_1.Solution.FloorInsulation:
        case solution_1.Solution.CrawlspaceInsulation:
            return noFloor || floorRc > 2.37 ? 7 : floorRc > 1.26 ? 4 : 0;
        case solution_1.Solution.InnerRoofInsulation:
        case solution_1.Solution.AtticFloorInsulation:
            return noRoof || roofRc > 1.33 ? 3 : 0;
        case solution_1.Solution.WindowGlazing:
            return (0, exports.getGlazingComfortScore)(livingU) + (0, exports.getGlazingComfortScore)(sleepingU);
        case solution_1.Solution.AirToAirHeatPump:
            return 20;
        case solution_1.Solution.CentralHeatingBoiler:
        case solution_1.Solution.HybridHeatPump:
        case solution_1.Solution.ElectricHeatPump:
            return heatEmissionSystems.some(s => s.includes('UnderfloorHeating')) ? 20 : 15;
        case solution_1.Solution.PvSystem:
        case solution_1.Solution.WindowFrames:
        default:
            return 0;
    }
}
exports.getCurrentSolutionComfort = getCurrentSolutionComfort;
exports.maxPointsPerSolution = {
    [solution_1.Solution.WallInsulation]: 5,
    [solution_1.Solution.FloorInsulation]: 7,
    [solution_1.Solution.CrawlspaceInsulation]: 7,
    [solution_1.Solution.InnerRoofInsulation]: 3,
    [solution_1.Solution.AtticFloorInsulation]: 3,
    [solution_1.Solution.WindowGlazing]: 6,
    [solution_1.Solution.CentralHeatingBoiler]: 20,
    [solution_1.Solution.HybridHeatPump]: 20,
    [solution_1.Solution.AirToAirHeatPump]: 20,
    [solution_1.Solution.ElectricHeatPump]: 20,
    [solution_1.Solution.PvSystem]: 0,
    [solution_1.Solution.WindowFrames]: 0,
    [solution_1.Solution.Miscellaneous]: 0,
    [solution_1.Solution.Sedum]: 0,
    [solution_1.Solution.ChargingBox]: 0,
    weatherStripping: 10,
    ventilation: 10,
    underfloorHeating: 10,
    homeBattery: 0,
};
function getComfortDeltaBySolution(comfortScoreDelta, solution) {
    if (exports.maxPointsPerSolution[solution] > 0) {
        return (comfortScoreDelta / exports.maxPointsPerSolution[solution]) * 5;
    }
    return 0;
}
exports.getComfortDeltaBySolution = getComfortDeltaBySolution;
function getComfortStarsPerSolution(solution, comfortProps, comfortScoreDelta) {
    const currentSolutionComfort = getCurrentSolutionComfort(solution, comfortProps);
    // NOTE: This needs to be maxed to the maxPointsPerSolution, so wall and roof don't count 10 extra points for weatherStripping in some cases
    const singleSolutionDelta = Math.min(solution === 'wallInsulation' ? 3 : exports.maxPointsPerSolution[solution], comfortScoreDelta);
    const newSolutionComfort = currentSolutionComfort + singleSolutionDelta;
    const currStars = Math.max(1, Math.min(5, Math.floor(getComfortDeltaBySolution(currentSolutionComfort, solution))));
    const newStars = Math.ceil(getComfortDeltaBySolution(newSolutionComfort, solution));
    const starsToAdd = Math.max(0, newStars - currStars);
    const leftoverStars = 5 - starsToAdd - currStars;
    return { currStars, starsToAdd, leftoverStars };
}
exports.getComfortStarsPerSolution = getComfortStarsPerSolution;
